import React from 'react';

const Contact: React.FC = () => <section aria-label="contact" />;

export default Contact;
